import { render, staticRenderFns } from "./StatisticsCardVertical.vue?vue&type=template&id=0060191f&scoped=true&"
import script from "./StatisticsCardVertical.vue?vue&type=script&lang=js&"
export * from "./StatisticsCardVertical.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsCardVertical.vue?vue&type=style&index=0&id=0060191f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0060191f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
